export default __webpack_public_path__ + "static/media/cover.21e48e44.jpg";